import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { AccordionContext, Card, useAccordionToggle } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";
export const ContextAwareToggle = ({ children, eventKey, callback }) => {
    const currentEventKey = useContext(AccordionContext);
    const decoratedOnClick = useAccordionToggle(eventKey, () => callback && callback(eventKey));
    const [currentIcon, setCurrentIcon] = useState(faChevronRight);
    useEffect(() => {
        if (currentEventKey === eventKey) {
            setCurrentIcon(faChevronDown);
        }
        else {
            setCurrentIcon(faChevronRight);
        }
    }, [currentEventKey]);
    return (_jsxs(Card.Header, { className: "clickable", onClick: decoratedOnClick, children: [_jsx(FontAwesomeIcon, { icon: currentIcon }), "\u00A0 \u00A0", children] }));
};
